import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-form-select-list',
    templateUrl: './pr-form-select-list.component.html',
    styleUrls: ['./pr-form-select-list.component.scss'],
    standalone: false
})
export class PrFormSelectListComponent implements OnInit {
  loading = false;
  @Input() clazz: string;

  constructor() {}

  ngOnInit() {}
}
